export default __webpack_public_path__ + "static/media/4 - Alberto Ministerio dos Filmes.cd4440a8.jpg";